import languages from "../languages/zh-CN/index";
import menu from "./zh-CN/menu";

export default {
  ...menu,
  ...languages,
};
